module.exports = __webpack_public_path__ + "static/media/barber_la.836a36bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/personal/normals/barber_la.jpg
// module id = 400
// module chunks = 0